module.exports = __webpack_public_path__ + "static/infrastructureRight-33b9c3abf506e3ec5ac9352e12d4fc0a.svg";